<template>
  <div class="page">

    <h1>Bank Transfer Deposit</h1>

    <BackButton
      text="Back to Deposit Menu"
      @click="backmenu"
    />

    <div class="callback-container">

      <!-- Success state -->
      <div v-if="isSuccess" class="status-card success">
        <div class="status-icon">✔</div>
        <h2>Transaction Successful!</h2>
        <p class="status-sub">Your bank transfer has been received and is being processed.</p>

        <div class="detail-block">
          <div class="detail-row">
            <span class="detail-label">Username</span>
            <span class="detail-value">{{ username }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Reference</span>
            <div class="detail-copy-row">
              <span class="detail-value highlight">{{ reference }}</span>
              <button class="btn-copy" @click="copyReference">
                {{ copied ? '✔ Copied' : 'Copy' }}
              </button>
            </div>
          </div>
        </div>

        <p class="notice">
          Your deposit will appear on your
          <strong>wsbetting.co.mw</strong> account shortly.<br>
          If it doesn't appear within 30 minutes,
          <a href="javascript:void(0)" @click="redirectContact">CLICK HERE</a> to contact us.
        </p>
      </div>

      <!-- Error / unknown state -->
      <div v-else class="status-card error">
        <div class="status-icon">✖</div>
        <h2>Transaction Not Found</h2>
        <p class="status-sub">We could not confirm your transaction. Please check your reference and try again or contact support.</p>

        <div v-if="reference" class="detail-block">
          <div class="detail-row">
            <span class="detail-label">Reference</span>
            <span class="detail-value highlight">{{ reference }}</span>
          </div>
        </div>

        <p class="notice">
          <a href="javascript:void(0)" @click="redirectContact">CLICK HERE</a> to contact us if you believe this is an error.
        </p>
      </div>

    </div>

  </div>
</template>

<script>
import BackButton from '@/components/BackButton.vue';

export default {
  components: { BackButton },
  data() {
    return {
      username: this.$route.query.username || 'Unknown User',
      reference: this.$route.query.reference || '',
      copied: false
    };
  },
  computed: {
    isSuccess() {
      return !!this.reference;
    }
  },
  methods: {
    backmenu() {
      this.$router.push({
        name: 'DepositWebsiteMalawi',
        query: { username: this.$route.query.username }
      });
    },
    redirectContact() {
      window.parent.postMessage({ action: 'btncontact' }, '*');
    },
    copyReference() {
      navigator.clipboard.writeText(this.reference).then(() => {
        this.copied = true;
        setTimeout(() => { this.copied = false; }, 2000);
      });
    },
    sendHeight() {
      const height = document.body.scrollHeight;
      window.parent.postMessage({ iframeHeight: height }, '*');
    }
  },
  mounted() {
    window.parent.postMessage({ action: 'payment_finalised' }, '*');
    this.sendHeight();
    window.addEventListener('resize', this.sendHeight);
  },
  updated() {
    this.$nextTick(() => this.sendHeight());
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.sendHeight);
  }
};
</script>

<style scoped>
h1 {
  color: #000;
  text-align: center;
  font-weight: 800;
  padding: 15px;
}

.page {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.callback-container {
  display: flex;
  justify-content: center;
  padding: 20px 16px 30px;
}

/* ── Status card ── */
.status-card {
  width: 100%;
  max-width: 460px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  background: #fff;
  padding: 32px 28px;
  text-align: center;
}

.status-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  font-size: 28px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
}

.success .status-icon {
  background-color: #e6f4ea;
  color: #1e8e3e;
}

.error .status-icon {
  background-color: #fdecea;
  color: #d93025;
}

.status-card h2 {
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 8px;
}

.success h2 { color: #1e8e3e; }
.error h2   { color: #d93025; }

.status-sub {
  font-size: 14px;
  color: #666;
  margin: 0 0 24px;
}

/* ── Detail block ── */
.detail-block {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 20px;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.detail-label {
  font-size: 12px;
  font-weight: 700;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  flex-shrink: 0;
}

.detail-value {
  font-size: 14px;
  font-weight: 600;
  color: #1a2332;
  text-align: right;
}

.detail-copy-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.highlight {
  background: #f0f4ff;
  padding: 4px 10px;
  border-radius: 4px;
  font-family: monospace;
  font-size: 13px;
  color: #1a2332;
  letter-spacing: 0.5px;
}

.btn-copy {
  padding: 4px 10px;
  font-size: 11px;
  border: 1px solid #1a73e8;
  border-radius: 4px;
  color: #1a73e8;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.btn-copy:hover {
  background: #1a73e8;
  color: #fff;
}

/* ── Notice text ── */
.notice {
  font-size: 13px;
  color: #555;
  line-height: 1.7;
  margin: 0;
}

.notice a {
  color: #1a73e8;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
}

.notice a:hover {
  text-decoration: underline;
}
</style>
